import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const inventoryTagsQueryAtom = createQueryAtomFactory(
  'trade.inventoryTags',
  (params?: { itemIds?: string[]; facilityId?: string }) => ({
    inventoryTags: {
      __args: {
        filter:
          params?.itemIds?.length || params?.facilityId
            ? {
                itemIds: params?.itemIds?.length ? params.itemIds : undefined,
                facilityIds: params?.facilityId
                  ? [params.facilityId]
                  : undefined,
              }
            : undefined,
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        tagNumber: true,
        tagType: true,
        generatedAt: true,
        status: true,
        grossQuantity: true,
        tare: true,
        netQuantity: true,
        item: {
          id: true,
          name: true,
          skuNumber: true,
          itemGroup: {
            id: true,
            name: true,
          },
        },
        facilityId: true,
        isRevised: true,
        quantityCaptureMethod: true,
        tareCaptureMethod: true,
        customAttributes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
);
